import { isEmpty } from 'lodash-es';
import { logout as logUserOut } from 'wisestep-api';

export function getCookieByName(name: string) {
  const pattern = RegExp(name + '=.[^;]*');
  const matched = document.cookie.match(pattern);
  if (matched) {
    const cookie = matched[0].split('=');
    return cookie[1];
  }
  return null;
}

export function setCookieByName(name: string, value: string, days: number) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function deleteCookieByName(name: string) {
  const d = new Date();
  d.setTime(d.getTime());
  const expires = 'expires=' + d.toUTCString();
  const url = window.location.hostname.split('.');
  document.cookie = name + '=' + '' + ';domain=.' + url[1] + '.' + url[2] + ';path=/;' + expires;
}

export const getAuthToken = () => getCookieByName('Authorization');

export const logout = async () => {
  try {
    await logUserOut();
    logoutUser();
  } catch (e) {
    logoutUser();
  }
  if (process.env.REACT_APP_URL) {
    window.location.href = process.env.REACT_APP_URL;
  }
};

export const logoutUser = () => {
  const navigationurl = getNavURL();
  deleteCookieByName('X-Workspace-Tokens');
  deleteCookieByName('Authorization');
  window.localStorage.clear();
  if (!isEmpty(navigationurl)) {
    setNavURL(navigationurl);
  }
  window.location.href = window.location.origin;
};

export const logoutFromAllApps = (workspaceLink: string) => {
  logoutUser();
  window.location.href = `https://${workspaceLink}.wisestep.com/#/regroot-logout`;
};

export const getWorkspaceToken = () => window.localStorage.getItem('workspace');

export const setWorkspaceToken = (token: string) => window.localStorage.setItem('workspace', token);

export const getNavURL = () => window.localStorage.getItem('navigationurl');

export const setNavURL = (url: string | null) => {
  if (url) {
    window.localStorage.setItem('navigationurl', url);
  } else {
    window.localStorage.removeItem('navigationurl');
  }
};

export const navigateToOTp = () => {
  window.location.href = window.location.origin + '/workspace-otp';
};

export const mapExtensionUrlWithNewUrl = () => {
  let url: {
    isCandidateId: boolean;
    candidateId?: string;
    value: string;
  } | null = null;
  if (location.href) {
    const params = new URLSearchParams(new URL(location.href).search);
    if (location.href.includes('/task?id=')) {
      const candidateEmail = params.get('email');
      url = {
        isCandidateId: false,
        value: `/tasks/${candidateEmail}`,
      };
    } else if (location.href.includes('candidate-crm')) {
      const id = params.get('id');
      const jobId = params.get('jobid');
      if (id && jobId) {
        url = {
          isCandidateId: true,
          candidateId: id,
          value: `/jobs-crm/${jobId}/false/0/pipeline`,
        };
      }
    }
  }

  return url;
};
